/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusChallengeResponse
 */
export interface StatusChallengeResponse {
    /**
     * 
     * @type {number}
     * @memberof StatusChallengeResponse
     */
    statusChallengeId?: number;
}

/**
 * Check if a given object implements the StatusChallengeResponse interface.
 */
export function instanceOfStatusChallengeResponse(value: object): value is StatusChallengeResponse {
    return true;
}

export function StatusChallengeResponseFromJSON(json: any): StatusChallengeResponse {
    return StatusChallengeResponseFromJSONTyped(json, false);
}

export function StatusChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'statusChallengeId': json['status_challenge_id'] == null ? undefined : json['status_challenge_id'],
    };
}

export function StatusChallengeResponseToJSON(json: any): StatusChallengeResponse {
    return StatusChallengeResponseToJSONTyped(json, false);
}

export function StatusChallengeResponseToJSONTyped(value?: StatusChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_challenge_id': value['statusChallengeId'],
    };
}

